// src/sot/primitives/TopBarRx.jsx
import React from "react";
import { ChevronLeft, X as XIcon } from "lucide-react";
import "@/styles/afrimed.css";
import "@/sot/afrimed-design-system.css";

export default function TopBarRx({
  title = "",
  meta = "",
  subtitle = "",
  onBack,
  close = false,
  right = null,
  className = "",
  margin = "mb-4 md:mb-5",
  titleClassName = "text-headline-medium text-on-surface truncate",
  metaClassName = "mt-1 text-body-medium text-on-surface truncate",
  subtitleClassName = "text-body-medium text-on-surface-var truncate",
}) {
  return (
    <header className={["w-full", className, margin].filter(Boolean).join(" ")}>
      <div style={{ height: "env(safe-area-inset-top)" }} />

      <div className="relative h-14 w-full">
        <div className="absolute inset-y-0 left-0 flex items-center">
          <button
            type="button"
            aria-label={close ? "Close" : "Back"}
            onClick={onBack}
            className={[
              "inline-flex h-10 w-10 items-center justify-center rounded-[12px]",
              "bg-[rgba(var(--clr-on-surface),0.08)] text-on-surface",
              "transition-colors hover:bg-[rgba(var(--clr-on-surface),0.12)]",
              "focus:outline-none focus-visible:ring-2 focus-visible:ring-[rgba(var(--clr-on-surface),0.18)]",
            ].join(" ")}
          >
            {close ? <XIcon className="h-5 w-5" aria-hidden /> : <ChevronLeft className="h-5 w-5" aria-hidden />}
          </button>
        </div>

        {right ? (
          <div className="absolute inset-y-0 right-0 flex items-center justify-end">
            {right}
          </div>
        ) : null}
      </div>

      <div className="h-10" aria-hidden="true" />

      <div className="w-full pb-7">
        {title ? <h1 className={titleClassName}>{title}</h1> : null}
        {meta ? <div className={metaClassName}>{meta}</div> : null}
        {subtitle ? <p className={["mt-0", subtitleClassName].join(" ")}>{subtitle}</p> : null}
      </div>
    </header>
  );
}
